import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Description = ({ listDescription }) => {
    return (
        <div className="teboil-description">
            <FullWrapper>
                <div className="teboil-descriptionWrapper">
                    {listDescription.map((item, index) => (
                        <div className="teboil-descriptionLeft" key={index}>
                            <div className="teboil-descriptionTitle">{item.title}</div>
                            {item.list.map((list, idx) => (
                                <div className="teboil-descriptionItem" key={idx}>
                                    <div
                                        className="teboil-descriptionText"
                                        dangerouslySetInnerHTML={{ __html: list.text }}
                                    />
                                </div>
                            ))}
                        </div>
                    ))}
                    <img
                        src="/images/pic/teboil/description.jpg"
                        alt="description"
                        className="teboil-descriptionRight"
                    />
                </div>
            </FullWrapper>
        </div>
    );
};

export default Description;
